/**
 * @module events/types/pointerLeave
 */

/**
 * @type {string}
 */
export default 'pointerleave'
